export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";